import {
  MODEL_ID,
  PROVIDER,
  ACTION,
  MODE,
  MODEL_FORMAT_OUTPUT,
  POLYGON_TYPE,
  MATERIAL,
  VIEW_TYPE,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": MODEL_ID.MESHY_IMAGE_TO_3D_PRO,
  "provider": PROVIDER.MESHY,
  "action": ACTION.IMAGE_TO_3D,
  "mode": MODE.NORMAL,
  "input_schema": {
    "type": "object",
    "properties": {
      "input_image": {
        "type": "string",
        "allowedTypes": ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
        "maxFileSize": 100 * 1024 * 1024,
        // Multi-view limits from cgt-ai-studio-schema: accepted labelled views in the
        // provider's order, and how many images a multi-view run may carry.
        "multiView": {
          "viewTypes": [VIEW_TYPE.FRONT, VIEW_TYPE.LEFT, VIEW_TYPE.BACK, VIEW_TYPE.RIGHT],
          // Meshy accepts a single image here, but one image is the Single Image tab's
          // job; multi-view asks for at least two angles like the other engines.
          "minItems": 2,
          "maxItems": 4,
        },
      },
      "multiview_input": {
        "type": "boolean",
      },
      "polygon_type": {
        "type": "string",
        "enum": [POLYGON_TYPE.TRIANGLE, POLYGON_TYPE.QUADRILATERAL],
        "default": POLYGON_TYPE.TRIANGLE,
      },
      "target_polycount": {
        "type": "integer",
        "oneOf": [
          {
            "if": {
              "properties": { "smart_low_poly": { "const": true } },
              "required": ["smart_low_poly"],
            },
            "then": {
              "properties": {
                "target_polycount": { "minimum": 100, "maximum": 15000, "default": 4000 },
              },
            },
          },
          {
            "if": {
              "properties": { "smart_low_poly": { "const": false } },
              "required": ["smart_low_poly"],
            },
            "then": {
              "properties": {
                "target_polycount": { "minimum": 10000, "maximum": 300000, "default": 150000 },
              },
            },
          },
        ],
      },
      "material": {
        "type": "string",
        "enum": [MATERIAL.GEOMETRY_ONLY, MATERIAL.BASIC, MATERIAL.PBR],
        "default": MATERIAL.BASIC,
      },
      "smart_low_poly": {
        "type": "boolean",
        "default": false,
      },
      "ultra_mode": {
        "type": "boolean",
        "default": false,
      },
    },
    "required": ["input_image"],
    "allOf": [
      {
        "if": {
          "properties": { "material": { "enum": [MATERIAL.GEOMETRY_ONLY, MATERIAL.BASIC, MATERIAL.PBR] } },
          "required": ["material"],
        },
        "then": false,
      },
      {
        "if": {
          "properties": { "polygon_type": { "const": POLYGON_TYPE.TRIANGLE } },
          "required": ["polygon_type"],
        },
        "then": {
          "properties": {
            "model_format_output": { "const": MODEL_FORMAT_OUTPUT.GLB },
          },
        },
      },
      {
        "if": {
          "properties": { "polygon_type": { "const": POLYGON_TYPE.QUADRILATERAL } },
          "required": ["polygon_type"],
        },
        "then": {
          "properties": {
            "model_format_output": { "const": MODEL_FORMAT_OUTPUT.FBX },
            "should_remesh": { "const": true },
          },
        },
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.GEOMETRY_ONLY } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "geometry_only": { "const": true },
            "enable_pbr": { "const": false },
          },
        },
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.BASIC } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "geometry_only": { "const": false },
            "enable_pbr": { "const": false },
          },
        },
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.PBR } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "geometry_only": { "const": false },
            "enable_pbr": { "const": true },
          },
        },
      },
      {
        "if": {
          "properties": { "smart_low_poly": { "const": true } },
          "required": ["smart_low_poly"],
        },
        "then": {
          "properties": {
            "generate_type": { "const": 'LowPoly' },
            "polygon_type": false,
            "ultra_mode": { "const": false },
          },
        },
      },
      {
        "if": {
          "properties": { "smart_low_poly": { "const": false } },
          "required": ["smart_low_poly"],
        },
        "then": false,
      },
    ],
  },
  "ui_schema": {},
  "keyToConvert": [
    { "from": "polygon_type", "to": "topology" },
  ],
  "active_if": {},
}
